import urlApi from './urlApi';
export var GET_INDUSTRY_IMAGE_REQUEST = 'GET_INDUSTRY_IMAGE_REQUEST';
export var GET_INDUSTRY_IMAGE_SUCCESS = 'GET_INDUSTRY_IMAGE_SUCCESS';
export var GET_INDUSTRY_IMAGE_ERROR = 'GET_INDUSTRY_IMAGE_ERROR';
export function getIndustry(url) {
    return function (dispatch) {
        dispatch({
            type: GET_INDUSTRY_IMAGE_REQUEST,
        });
        urlApi().getIndustryImage(url).then(function (res) {
            dispatch({
                type: GET_INDUSTRY_IMAGE_SUCCESS,
                payload: res,
            });
        }).catch(function (e) {
            dispatch({
                type: GET_INDUSTRY_IMAGE_ERROR,
            });
        });
    };
}
//# sourceMappingURL=getIndustryImage.js.mapimport urlApi from './urlApi';
export var GET_INDUSTRY_IMAGE_REQUEST = 'GET_INDUSTRY_IMAGE_REQUEST';
export var GET_INDUSTRY_IMAGE_SUCCESS = 'GET_INDUSTRY_IMAGE_SUCCESS';
export var GET_INDUSTRY_IMAGE_ERROR = 'GET_INDUSTRY_IMAGE_ERROR';
export function getIndustry(url) {
    return function (dispatch) {
        dispatch({
            type: GET_INDUSTRY_IMAGE_REQUEST,
        });
        urlApi().getIndustryImage(url).then(function (res) {
            dispatch({
                type: GET_INDUSTRY_IMAGE_SUCCESS,
                payload: res,
            });
        }).catch(function (e) {
            dispatch({
                type: GET_INDUSTRY_IMAGE_ERROR,
            });
        });
    };
}
//# sourceMappingURL=getIndustryImage.js.map